import copyToClipboard from 'copy-to-clipboard';

import {urlPrefixed} from '../../../config';
import {User} from '../../../generated/graphql';
import {getUserStatus} from '../../../pages/OrgDashboard/utils';
import {LastActiveSort, UserStatus} from '../util';

export const copyTokenLink = async (email: string, path: string) => {
  // invite and password reset use the same token claims,
  // the difference is just whether the user already exists
  const resp = await fetch(urlPrefixed('/admin/token'), {
    method: 'POST',
    body: JSON.stringify({email}),
  });
  const data: {token: string | null} = await resp.json();

  let url = document.location.origin + path;
  if (data.token != null) {
    url += `?jwt=${data.token}`;
  }
  copyToClipboard(url);
};

export const getTableUserDisplayName = (
  user: Partial<User>,
  givenStatus?: UserStatus
): string => {
  const status = givenStatus || getUserStatus(user);
  if (user.name) {
    return user.name;
  }
  if (user.accountType === 'SERVICE') {
    return 'Service';
  }
  if (status === 'Pending') {
    return 'New user';
  }
  if (status === 'Deactivated') {
    return 'Deactivated user';
  }
  return 'Unnamed user';
};

export const sortLastActive = (a: LastActiveSort, b: LastActiveSort) => {
  // pending users are listed first
  if (a.status === 'Pending' && b.status !== 'Pending') {
    return 1;
  } else if (a.status !== 'Pending' && b.status === 'Pending') {
    return -1;
  }

  const aLastActiveAt = a.activity?.lastActiveAt;
  const bLastActiveAt = b.activity?.lastActiveAt;

  // users with no activity are pushed to the bottom
  if (aLastActiveAt && !bLastActiveAt) {
    return 1;
  } else if (!aLastActiveAt && bLastActiveAt) {
    return -1;
  }

  // sort by lastActiveAt if available; fallback to createdAt
  if (aLastActiveAt && bLastActiveAt) {
    return +new Date(aLastActiveAt) - +new Date(bLastActiveAt);
  }
  return +new Date(a.createdAt) - +new Date(b.createdAt);
};
